<template>
  <div>
    <template v-if="data.length">
      <RecommendCard
        v-for="(student, index) in data"
        :key="index"
        :child_img="student.image"
        :child_name="student.firstname + ' ' + student.lastname"
        :percent_progress="Number(student.score)"
        :data="student"
        :topic="
          student.recommendations.remedial
            ? student.recommendations.remedial
            : {}
        "
        :type="'Hard'"
        :reference_type="'class'"
        :student_id="student.id"
      ></RecommendCard>
    </template>
    <template v-else>
      <div
        class="empty-cover-block py-5 d-flex flex-column justify-content-center align-items-center"
      >
        <img v-lazy="localImg('EmptyWork.png')" alt="EmptyAssessment" />
        <div class="text-content mt-3 text-center color_ash font-14 px-2">
          You have no top student performance report.
        </div>
      </div>
    </template>

    <!-- GROUP REMEDIAL  -->
    <div class="group-remedial" v-if="data.length">
      <router-link
        to
        class="remedial-btn rounded-30"
        @click.native="toggleGroupRemedialModal"
      >
        <span class="icon-videocam brand_inverse font-23 ml-0 mr-2"></span>
        Schedule a group class
      </router-link>
    </div>
    <!-- GROUP REMEDIAL  -->

    <!-- RECOMMENDATION NOTE -->
    <RecommendationNote
      v-if="false"
      progress_state="top"
      recommendation_text="We advice that you focus on the following students while in class. Make sure they get it first before moving on."
    ></RecommendationNote>
    <!-- RECOMMENDATION NOTE -->

    <!-- MODAL -->
    <GroupRemedialModal
      v-if="group_remedial"
      :data="data"
      :topic="topic"
      :students="students"
      @scheduled="scheduled"
      @closeTriggered="toggleGroupRemedialModal"
    ></GroupRemedialModal>

    <RemidialSuccessModal
      v-if="show_alert"
      @closeTriggered="closeAlert"
      :message="'Remidial successfully added.'"
    ></RemidialSuccessModal>
    <!-- MODAL -->
  </div>
</template>

<script>
// import RecommendDefaultCard from "@/components/classComps/report/RecommendDefaultCard";
import RecommendCard from "@/components/classComps/report/RecommendCard";
export default {
  name: "TopList",
  props: ["data", "topic", "subject", "students"],
  components: {
    // RecommendDefaultCard,
    RecommendCard,
    RecommendationNote: () =>
      import(
        /* webpackChunkName: "Recommendation" */ "@/components/classComps/report/RecommendationNote"
      ),
    GroupRemedialModal: () =>
      import(
        /* webpackChunkName: "GroupRemedialModal" */ "@/components/modalComps/classModals/GroupRemedialModal"
      ),
    RemidialSuccessModal: () =>
      import(
        /* webpackChunkName: "alert" */ "@/components/modalComps/teacherModals/RemidialSuccessModal"
      ),
  },
  data() {
    return {
      group_remedial: false,
      show_alert: false,
    };
  },
  methods: {
    toggleGroupRemedialModal() {
      this.group_remedial = !this.group_remedial;
    },
    scheduled() {
      this.show_alert = true;
      this.group_remedial = false;
    },
    closeAlert() {
      this.show_alert = !this.show_alert;
    },
  },
};
</script>

<style lang="scss">
.group-remedial {
  width: 96%;
  margin: 20px auto;

  @include breakpoint_max(sm) {
    margin: 20px auto 0;
  }

  .remedial-btn {
    padding: 12px 22px;
    color: $brand_navy;
    font-size: 13px;
    background: $brand_inverse_light;

    @include breakpoint_max(sm) {
      padding: 10px 18px;
      font-size: 11.5px !important;
    }

    span {
      position: relative;
      top: 5px;

      @include breakpoint_max(sm) {
        top: 4px;
        font-size: 19px !important;
      }
    }
  }
}

.empty-cover-block {
  @include breakpoint_max(sm) {
    img {
      @include equal_min_edge(120);
    }

    .text-content {
      font-size: 12.5px !important;
    }
  }
}
</style>
